import React, { useMemo } from "react";
import { Chip } from "../../../ForBrands/ui/BrandUI";
import { ChipScroller } from "../../../ForBrands/ui/mobile/MobileUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { RosterTable, StatusLegend } from "../coachPieces";
import { filterPlayers, rosterCounts, swingArchetypes } from "../coachUtils";
import { ROSTER_FILTERS } from "./teamModel";

// Team · Roster (Figma 02 · Team Roster): filter chips with counts, the
// status legend and the roster table. Swing archetypes come from the whole
// roster, so a filtered view keeps each player's quadrant. On phones
// (2407:935) the chips scroll sideways to the screen edge and the table
// becomes player cards (RosterTable switches itself).
const TeamRosterTab = ({ players, filter, onFilter, onOpen, onVerify, verifyingId }) => {
  const phone = usePhoneTheme();
  const counts = useMemo(() => rosterCounts(players), [players]);
  const rows = useMemo(() => filterPlayers(players, filter), [players, filter]);
  const archetypes = useMemo(() => swingArchetypes(players), [players]);
  const chips = ROSTER_FILTERS.map((f) => (
    <Chip key={f.value} active={filter === f.value} count={counts[f.value]} onClick={() => onFilter(f.value)}>
      {f.label}
    </Chip>
  ));
  return (
    <>
      {phone ? <ChipScroller>{chips}</ChipScroller> : <div className="flex flex-wrap gap-[10px]">{chips}</div>}
      <StatusLegend />
      <RosterTable players={rows} archetypes={archetypes} onOpen={onOpen} onVerify={onVerify} verifyingId={verifyingId} />
    </>
  );
};

export default TeamRosterTab;
